import { UnstyledButton } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './SubPageHeader.module.scss';
import { Props } from './SubPageHeader.types';

const SubPageHeader = ({ title, onBack, rightElement }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <UnstyledButton className={styles.backButton} onClick={onBack}>
          <IconArrowLeft size={18} />
          <span>{t('expenses.backToFinances', 'Retour aux finances')}</span>
        </UnstyledButton>
        <h1 className={styles.title}>{title}</h1>
      </div>
      {rightElement && <div className={styles.right}>{rightElement}</div>}
    </div>
  );
};

export default SubPageHeader;
